import products1 from 'assets/images/products/img-1.png';
import products2 from 'assets/images/products/img-2.png';
import products3 from 'assets/images/products/img-3.png';
import products4 from 'assets/images/products/img-4.png';
import products5 from 'assets/images/products/img-5.png';
import products6 from 'assets/images/products/img-6.png';
import products7 from 'assets/images/products/img-7.png';
import products9 from 'assets/images/products/img-9.png';
import products10 from 'assets/images/products/img-10.png';
import products12 from 'assets/images/products/img-12.png';
import products15 from 'assets/images/products/img-15.png';


export const productData = [
    {
        id: 1,
        productImg: products10,
        productTitle: "World's most expensive t shirt",
        category: "Fashion",
        price: '266.24',
        deletprice: "$354.99",
        discount: "25%",
        rating: "4.9",
        stock: "Out of stock",
        color: ["secondary", "light", "dark"],
        size: ["s", "m", "l"],
        bg: 'danger',
        sortBy: "lowtohigh",
    },
    {
        id: 2,
        productImg: products15,
        productTitle: "Like Style Women Black Handbag",
        category: "Fashion",
        price: "742.00",
        discount: "0%",
        rating: "4.2",
        stock: "In stock",
        color: ["light", "dark"],
        bg: 'success',
        sortBy: "hightolow"
    },
    {
        id: 3,
        productImg: products1,
        productTitle: "Black Horn Backpack For Men Bags 30 L Backpack",
        category: "Grocery",
        price: "113.24",
        deletprice: "$150.99",
        discount: "25%",
        rating: "3.8",
        stock: "In stock",
        color: ["primary", "danger", "secondary"],
        size: ["s", "m", "l"],
        bg: 'success',
        sortBy: "lowtohigh",
    },
    {
        id: 4,
        productImg: products7,
        productTitle: "Innovative education book",
        category: "Kids",
        price: "96.26",
        discount: "0%",
        rating: "4.7",
        stock: "In stock",
        bg: 'success',
        sortBy: "lowtohigh",
    },
    {
        id: 5,
        productImg: products4,
        productTitle: "Sangria Girls Mint Green & Off-White Solid Open Toe Flats",
        category: "Kids",
        deletprice: "$94.26",
        price: '24.07',
        discount: "75%",
        rating: "4.7",
        stock: "In stock",
        color: ["success", "danger", "secondary"],
        size: ["40", "41", "42"],
        bg: 'success',
        sortBy: "lowtohigh",
    },
    {
        id: 6,
        productImg: products5,
        productTitle: "Lace-Up Casual Shoes For Men",
        category: "Fashion",
        price: "229.00",
        discount: "0%",
        rating: "4.0",
        stock: "Out of stock",
        color: ["danger"],
        size: ["40", "41", "42"],
        bg: 'danger',
        sortBy: "hightolow"
    },
    {
        id: 7,
        productImg: products6,
        productTitle: "Striped High Neck Casual Men Orange Sweater",
        category: "Fashion",
        price: '62.40',
        deletprice: "$120.00",
        discount: "48%",
        rating: "4.8",
        stock: "In stock",
        size: ["s", "m", "l", "xl"],
        bg: 'success',
        sortBy: "lowtohigh",
    },
    {
        id: 8,
        productImg: products9,
        productTitle: "Lace-Up Casual Shoes For Men",
        category: "Kids",
        deletprice: "$229.00",
        price: '194.65',
        discount: "15%",
        rating: "2.4",
        stock: "In stock",
        color: ["light", "warning"],
        size: ["s", "l"],
        bg: 'success',
        sortBy: "hightolow"
    },
    {
        id: 9,
        productImg: products10,
        productTitle: "Printed, Typography Men Round Neck Black T-shirt",
        category: "Fashion",
        price: "81.99",
        discount: "0%",
        rating: "4.9",
        stock: "In stock",
        color: ["dark", "light"],
        size: ["s", "m", "l", "xl"],
        bg: 'success',
        sortBy: "lowtohigh",
    },
    {
        id: 10,
        productImg: products12,
        productTitle: "Carven Lounge Chair Red",
        category: "Furniture",
        price: "209.99",
        discount: "0%",
        rating: "4.1",
        stock: "Out of stock",
        color: ["secondary", "dark", "danger", "light"],
        bg: 'danger',
        sortBy: "hightolow"
    },
    {
        id: 11,
        productImg: products3,
        productTitle: "Ninja Pro Max Smartwatch",
        category: "Watches",
        price: "309.09",
        discount: "20%",
        rating: "3.5",
        stock: "In stock",
        color: ["secondary", "info"],
        bg: 'success',
        sortBy: "hightolow"
    },
    {
        id: 12,
        productImg: products2,
        productTitle: "Opinion Striped Round Neck Green T-shirt",
        category: "Fashion",
        price: "126.99",
        discount: "0%",
        rating: "4.1",
        stock: "Out of stock",
        color: ["success"],
        size: ["s", "m", "l", "xl"],
        bg: 'danger',
        sortBy: "lowtohigh",
    }
]
